export const SERVICE_PROFILE = process.env.NEXT_PUBLIC_SERVICE_PROFILE as string;

/**
 * @type {boolean} 프로덕션에 배포된 인스턴스
 */
export const IS_PRODUCTION = process.env.NODE_ENV === 'production' && SERVICE_PROFILE === 'production';

export const SESSION_TOKEN = '__session';
